import React,{useState,useContext, useEffect, useCallback} from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axiosClient from '../../../../../services/axiosClient';

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";

//import FinancialChartMultipleData from './FinancialChartMultipleData';

// Enregistrer les composants Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);



const Home = () => {	
	const { changeBackground, background } = useContext(ThemeContext);
	
	// States pour les données du dashboard
	const [dashboardData, setDashboardData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	
	// Fonction pour récupérer les données du dashboard
	const fetchDashboardData = useCallback(async () => {
		try {
			setLoading(true);
			
			// axiosClient gère automatiquement X-AppApiToken et Authorization
			const response = await axiosClient.get('/admin/dashboard/data');
			
			const result = response.data;
			if (result.success) {
				setDashboardData(result.data);
				console.log('Dashboard data loaded:', result.data);
			} else {
				throw new Error('Données invalides reçues');
			}
		} catch (err) {
			console.error('Erreur API dashboard:', err);
			// Utiliser des données par défaut au lieu d'afficher une erreur
			setDashboardData({
				main_stats: {
					posts: { total: 0, activated: 0, unactivated: 0 },
					users: { total: 0, activated: 0, unactivated: 0 },
					payments: { total: 0, activated: 0, unactivated: 0 },
					categories: { total: 0, activated: 0, unactivated: 0 },
				},
				charts: {
					posts: [],
					users: [],
					payments: [],
				}
			});
		} finally {
			setLoading(false);
		}
	}, []); // useCallback dépendances vides

	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
		fetchDashboardData(); // Charger les données au montage du composant
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// Configuration des graphiques
	const getChartData = (chartData, label, color) => {
		return {
			labels: chartData?.map(item => item.date_formatted) || [],
			datasets: [
				{
					label: `${label} Activés`,
					data: chartData?.map(item => item.activated) || [],
					borderColor: color.primary,
					backgroundColor: color.primaryLight,
					tension: 0.4,
				},
				{
					label: `${label} Non Activés`,
					data: chartData?.map(item => item.unactivated) || [],
					borderColor: color.secondary,
					backgroundColor: color.secondaryLight,
					tension: 0.4,
				},
			],
		};
	};

	const chartOptions = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: 'top',
			},
		},
		scales: {
			y: {
				beginAtZero: true,
			},
		},
	};

	// Affichage pendant le chargement
	if (loading) {
		return (
			<div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Chargement du dashboard...</span>
				</div>
			</div>
		);
	}

	// Si pas de données, afficher un message simple
	if (!dashboardData) {
		return (
			<div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
				<div className="text-center">
					<div className="spinner-border text-primary mb-3" role="status">
						<span className="visually-hidden">Chargement...</span>
					</div>
					<p className="text-muted">Initialisation du dashboard...</p>
				</div>
			</div>
		);
	}

	return(
		<>
			<div className="row">
				<div className="col-xl-6">
				
					<div className="row">
						<div className="col-xl-12">
							<div className="card">
								<div className="card-body">
									<div className="row separate-row">
										<div className="col-sm-6">
											<div className="job-icon pb-4 d-flex justify-content-between">
												<div>
													<div className="d-flex align-items-center mb-1">
														<h2 className="mb-0 lh-1">{dashboardData?.main_stats?.posts?.total || 0}</h2>
														<span className="text-success ms-3">
															{dashboardData?.main_stats?.posts?.activated || 0} activées
														</span>
													</div>	
													<span className="fs-14 d-block mb-2">Annonces Total</span>
												</div>	
												<div className="stat-icon">
													<i className="fas fa-file-alt fa-2x text-white"></i>
												</div>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="job-icon pb-4 pt-4 pt-sm-0 d-flex justify-content-between">
												<div>
													<div className="d-flex align-items-center mb-1">
														<h2 className="mb-0 lh-1">{dashboardData?.main_stats?.users?.total || 0}</h2>
														<span className="text-info ms-3">
															{dashboardData?.main_stats?.users?.activated || 0} activés
														</span>
													</div>	
													<span className="fs-14 d-block mb-2">Utilisateurs Total</span>
												</div>	
												<div className="stat-icon">
													<i className="fas fa-users fa-2x text-white"></i>
												</div>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="job-icon pt-4 pb-sm-0 pb-4 pe-3 d-flex justify-content-between">
												<div>
													<div className="d-flex align-items-center mb-1">
														<h2 className="mb-0 lh-1">{dashboardData?.main_stats?.countries?.total || 0}</h2>
														<span className="text-warning ms-3">
															{dashboardData?.main_stats?.countries?.active || 0} actifs
														</span>
													</div>	
													<span className="fs-14 d-block mb-2">Pays</span>
												</div>	
												<div className="stat-icon">
													<i className="fas fa-globe fa-2x text-white"></i>
												</div>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="job-icon pt-4  d-flex justify-content-between">
												<div>
													<div className="d-flex align-items-center mb-1">
														<h2 className="mb-0 lh-1">
															{((dashboardData?.main_stats?.posts?.activated || 0) / (dashboardData?.main_stats?.posts?.total || 1) * 100).toFixed(1)}%
														</h2>
													</div>	
													<span className="fs-14 d-block mb-2">Taux d'Activation</span>
												</div>	
												<div className="stat-icon">
													<i className="fas fa-chart-line fa-2x text-white"></i>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header">
									<h4 className="card-title">Évolution des Annonces</h4>
									<button className="btn btn-outline-primary btn-sm" onClick={fetchDashboardData}>
										<i className="fas fa-sync-alt"></i> Actualiser
									</button>
								</div>
								<div className="card-body">
									<div style={{ height: '300px' }}>
										<Line 
											data={getChartData(dashboardData?.posts_chart, 'Annonces', {
												primary: '#007bff',
												primaryLight: 'rgba(0, 123, 255, 0.1)',
												secondary: '#dc3545',
												secondaryLight: 'rgba(220, 53, 69, 0.1)'
											})}
											options={chartOptions}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header">
									<h4 className="card-title">Évolution des Utilisateurs</h4>
								</div>
								<div className="card-body">
									<div style={{ height: '300px' }}>
										<Line 
											data={getChartData(dashboardData?.users_chart, 'Utilisateurs', {
												primary: '#28a745',
												primaryLight: 'rgba(40, 167, 69, 0.1)',
												secondary: '#ffc107',
												secondaryLight: 'rgba(255, 193, 7, 0.1)'
											})}
											options={chartOptions}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header d-flex justify-content-between align-items-center">
									<h4 className="card-title">Dernières Annonces</h4>
									<button className="btn btn-outline-primary btn-sm" onClick={fetchDashboardData}>
										<i className="fas fa-sync-alt"></i>
									</button>
								</div>
								<div className="card-body">
									{dashboardData?.latest_posts?.length > 0 ? (
										<div className="list-group list-group-flush">
											{dashboardData.latest_posts.slice(0, 5).map(post => (
												<div key={post.id} className="list-group-item border-0 px-0">
													<div className="d-flex justify-content-between align-items-start">
														<div className="flex-grow-1">
															<h6 className="mb-1 fw-bold">{post.title}</h6>
															<p className="mb-1 text-muted small">
																<i className="fas fa-user me-1"></i>Par {post.user}
															</p>
															<p className="mb-1 text-muted small">
																<i className="fas fa-building me-1"></i>{post.company || 'Entreprise non spécifiée'}
															</p>
															<small className="text-muted">
																<i className="fas fa-calendar me-1"></i>{post.created_at}
															</small>
														</div>
														<div className="text-end">
															<span className={`badge ${post.status === 'Activated' ? 'bg-success' : 'bg-warning'} mb-2`}>
																{post.status === 'Activated' ? 'Activée' : 'En attente'}
															</span>
															<br />
															<small className="text-muted">
																<i className="fas fa-eye me-1"></i>{post.views || 0} vues
															</small>
														</div>
													</div>
												</div>
											))}
										</div>
									) : (
										<div className="text-center py-4">
											<i className="fas fa-file-alt fa-3x text-muted mb-3"></i>
											<p className="text-muted">Aucune annonce récente</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-6">
					<div className="row">
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header d-flex justify-content-between align-items-center">
									<h4 className="card-title">Derniers Utilisateurs</h4>
									<small className="text-muted">
										Généré le: {dashboardData?.generated_at || new Date().toLocaleDateString()}
									</small>
								</div>
								<div className="card-body">
									{dashboardData?.latest_users?.length > 0 ? (
										<div className="list-group list-group-flush">
											{dashboardData.latest_users.slice(0, 5).map(user => (
												<div key={user.id} className="list-group-item border-0 px-0">
													<div className="d-flex justify-content-between align-items-start">
														<div className="flex-grow-1">
															<div className="d-flex align-items-center mb-2">
																<div className="avatar-sm me-3" style={{ width: '40px', height: '40px' }}>
																	<div className="avatar-title bg-primary rounded-circle text-white d-flex align-items-center justify-content-center fw-bold" style={{ width: '100%', height: '100%', fontSize: '16px' }}>
																		{user.name?.charAt(0)?.toUpperCase() || 'U'}
																	</div>
																</div>
																<div>
																	<h6 className="mb-1 fw-bold">{user.name}</h6>
																	<p className="mb-0 text-muted small">
																		<i className="fas fa-envelope me-1"></i>{user.email}
																	</p>
																</div>
															</div>
															<div className="d-flex align-items-center text-muted small">
																<span className="me-3">
																	<i className="fas fa-user-tag me-1"></i>
																	{user.user_type === 2 ? 'Consultant' : 'Entreprise'}
																</span>
																<span>
																	<i className="fas fa-calendar me-1"></i>{user.created_at}
																</span>
															</div>
														</div>
														<div className="text-end">
															<span className={`badge ${user.status === 'Activated' ? 'bg-success' : 'bg-warning'} mb-2`}>
																{user.status === 'Activated' ? 'Activé' : 'En attente'}
															</span>
															<br />
															<small className="text-muted">
																ID: {user.id}
															</small>
														</div>
													</div>
												</div>
											))}
										</div>
									) : (
										<div className="text-center py-4">
											<i className="fas fa-users fa-3x text-muted mb-3"></i>
											<p className="text-muted">Aucun utilisateur récent</p>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header">
									<h4 className="card-title">Résumé des Activités</h4>
								</div>
								<div className="card-body">
									<div className="row text-center">
										<div className="col-6">
											<div className="border-end">
												<h5 className="text-primary mb-1">
													{dashboardData?.main_stats?.posts?.total || 0}
												</h5>
												<p className="text-muted mb-0 small">Total Annonces</p>
											</div>
										</div>
										<div className="col-6">
											<h5 className="text-success mb-1">
												{dashboardData?.main_stats?.users?.total || 0}
											</h5>
											<p className="text-muted mb-0 small">Total Utilisateurs</p>
										</div>
									</div>
									<hr className="my-3" />
									<div className="row text-center">
										<div className="col-6">
											<div className="border-end">
												<h6 className="text-warning mb-1">
													{dashboardData?.main_stats?.posts?.activated || 0}
												</h6>
												<p className="text-muted mb-0 small">Annonces Activées</p>
											</div>
										</div>
										<div className="col-6">
											<h6 className="text-info mb-1">
												{dashboardData?.main_stats?.users?.activated || 0}
											</h6>
											<p className="text-muted mb-0 small">Utilisateurs Activés</p>
										</div>
									</div>
								</div>
							</div>
						</div>
		
					</div>
				</div>
			</div>	
		</>
	)
}
export default Home;